import { render } from "./ButtonProviderAndGame.vue?vue&type=template&id=051ae58c"
import script from "./ButtonProviderAndGame.vue?vue&type=script&lang=js"
export * from "./ButtonProviderAndGame.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__